/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_REQUIRED_MINIMUM_DISTRIBUTION =
  'REQUESTED_REQUIRED_MINIMUM_DISTRIBUTION';
export const requestedRequiredMinimumDistribution = () => {
  return {
    type: REQUESTED_REQUIRED_MINIMUM_DISTRIBUTION
  };
};

export const RECEIVED_REQUIRED_MINIMUM_DISTRIBUTION =
  'RECEIVED_REQUIRED_MINIMUM_DISTRIBUTION';
export const receivedRequiredMinimumDistribution = (
  requiredMinimumDistribution
) => ({
  type: RECEIVED_REQUIRED_MINIMUM_DISTRIBUTION,
  requiredMinimumDistribution
});

export const ERROR_REQUIRED_MINIMUM_DISTRIBUTION =
  'ERROR_REQUIRED_MINIMUM_DISTRIBUTION';
export const errorRequiredMinimumDistribution = (error) => ({
  type: ERROR_REQUIRED_MINIMUM_DISTRIBUTION,
  error
});
